// extracted by mini-css-extract-plugin
export default {"mCard":"fE-z","image":"gE-z","imageNoBackground":"hE-z","imageHasCategory":"iE-z","fullWidth":"jE-z"};